// Besuchen Sie für die komplette API-Dokumentation einschließlich Codebeispielen http://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...
$w("#button36, #button38, #button39, #button40").show();
});